module.exports = __webpack_public_path__ + "static/img/ic_video_unlock.7251968c.png";